import { startVisualiser } from './app.js';
import { JELLY_SHAPES } from './morph/shapes/jellies.js';
import { setStatus } from './ui/controls.js';

/*
 * The jellyfish page: nothing but jellyfish, built around the music. A stronger
 * pulse makes every bell throb with the bass, and the jelly-only registry means
 * each form morphs into another species, divides into a bloom of up to four, or
 * gathers a bloom back into a single animal — re-coloured on every visit.
 */
try {
  // `pulse: 3` matches the pulse slider's starting position in jellyfish.html.
  await startVisualiser({ shapes: JELLY_SHAPES, pulse: 3, characterUrl: null });
} catch (error) {
  console.error('Failed to start the jellyfish visualiser:', error);
  setStatus('Failed to start — this browser may not support WebGPU or WebGL2.');
}
